import { h } from 'preact'

export const ReassuranceReseau = ({ title, image, alt, description, CTA, cacheKey }) => {
   let cappingAdv
   if (CTA.analytics.pdbTa !== undefined && CTA.analytics.advCanal !== undefined && CTA.analytics.advCappingdata !== undefined) {
      cappingAdv = {
         'data-pdb-ta': CTA.analytics.pdbTa,
         'data-adv-canal': CTA.analytics.advCanal,
         'data-adv-cappingdata': CTA.analytics.advCappingdata,
      }
   }

   return (
      <div
         class="lien-composite reassurance-reseau py-0"
         data-testid="bande-reassurance-reseau"
         data-cache-key={cacheKey}
         data-pdb-zid={CTA.analytics.pdbZid}
         data-pdb-sc={CTA.analytics.pdbSc}
         data-pdb-idc={CTA.analytics.pdbIdc}
         data-pdb-vi={CTA.analytics.pdbVi}
         {...cappingAdv}
         data-oevent-category={CTA.analytics.oeventCategory}
         data-oevent-action={CTA.analytics.oeventAction}
         data-oevent-label={CTA.analytics.oeventLabel}
         data-oevent-other={CTA.analytics.oeventOther}
      >
         <img src={`${image}?saveas=webp`} alt={alt} loading="lazy" class="bg-img" />
         <div class="container-fluid bloc-txt">
            <div class="row">
               <div class="col-12 col-md-8 col-lg-6 mt-2 mb-2 text-white">
                  <h2 class="h3 mb-1">{title}</h2>
                  <p class="w-50 w-md-75 lead mb-0">{description}</p>
               </div>
               <div class="col-12 text-center text-sm-left mb-2">
                  <a href={CTA.URL} aria-label={CTA.ariaLabel} class="btn btn-primary btn-inverse">
                     {CTA.label}
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}
